import { render, staticRenderFns } from "./PatientDocument.vue?vue&type=template&id=36203f0a&scoped=true&"
import script from "./PatientDocument.vue?vue&type=script&lang=js&"
export * from "./PatientDocument.vue?vue&type=script&lang=js&"
import style0 from "./PatientDocument.vue?vue&type=style&index=0&id=36203f0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36203f0a",
  null
  
)

export default component.exports